import { render } from "./BaseHorizontalBarChart.vue?vue&type=template&id=6ee8e28c&scoped=true"
import script from "./BaseHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./BaseHorizontalBarChart.vue?vue&type=script&lang=js"

import "./BaseHorizontalBarChart.vue?vue&type=style&index=0&id=6ee8e28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee8e28c"],['__file',"src/components/charts/BaseHorizontalBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee8e28c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee8e28c', __exports__)) {
    api.reload('6ee8e28c', __exports__)
  }
  
  module.hot.accept("./BaseHorizontalBarChart.vue?vue&type=template&id=6ee8e28c&scoped=true", () => {
    api.rerender('6ee8e28c', render)
  })

}


export default __exports__